import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const BrandingContext = createContext({
  logo: null,
  primaryColor: '#7A6EFE',
  clinicName: 'Vistaar',
  currency: '₹',
});

export const useBranding = () => useContext(BrandingContext);

const toTitleCase = (str) => (str || '').replace(/(^|\s)\S/g, (c) => c.toUpperCase());

export const BrandingProvider = ({ children }) => {
  const clinicBranding = useSelector(state => state.auth.clinicBranding);
  const [branding, setBranding] = useState({
    logo: null,
    primaryColor: '#7A6EFE',
    clinicName: 'Vistaar',
    currency: '₹',
  });

  useEffect(() => {
    if (clinicBranding) {
      const rawLogo = clinicBranding.logo_url;
      let logoUrl = null;
      if (rawLogo) {
        logoUrl = rawLogo.startsWith('http') ? rawLogo : `${process.env.REACT_APP_STAFF_PROFILE_IMAGE_URL || ''}${rawLogo}`;
      }
      setBranding({
        logo: logoUrl,
        primaryColor: clinicBranding.primary_color || '#7A6EFE',
        clinicName: toTitleCase(clinicBranding.name || 'Vistaar'),
        currency: clinicBranding.currency || '₹',
      });
    }
  }, [clinicBranding]);

  useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', branding.primaryColor);
  }, [branding.primaryColor]);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
};
